module.exports = __webpack_public_path__ + "static/aboutus-4557e60529dc1c1d81735e5747edaf4e.jpg";